<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// import Watermark from '../src/api/watermark'
import store from './store'
import { setTokenInCookie } from './utils/index'
export default {
  name: 'App',
  created(){
    // admin
    // setTokenInCookie("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NTAxNjQ2ODAsInVzZXJfaW5mbyI6eyJ1c2VyX2lkIjoiMSIsInVzZXJfbmFtZSI6ImFkbWluIiwicmVhbF9uYW1lIjoiYWRtaW4iLCJkZXBhcnRtZW50X2lkIjoiMCIsInBvc2l0aW9uX2lkIjoiMCIsImFnZW5jeV9pZCI6IjAifX0.AJ92W-qpkixl2aYe39IfBqJoCCl5GNC6f2LneAFvIgo")
    store.dispatch('user/getToken')
  },
  mounted(){
    // Watermark.set("请勿传播")
  }
}
function banBackSpace(e){
  var ev = e || window.event;//获取event对象
  var obj = ev.relatedTarget || ev.srcElement || ev.target || ev.currentTarget;//获取事件源
  var t = obj.type || obj.getAttribute('type');//获取事件源类型
  //获取作为判断条件的事件类型
  var vReadOnly = obj.getAttribute('readonly');
  //处理null值情况
  vReadOnly = (vReadOnly == "") ? false : vReadOnly;
  //当敲Backspace键时，事件源类型为密码或单行、多行文本的，
  //并且readonly属性为true或enabled属性为false的，则退格键失效
  var flag1=(ev.keyCode == 8 && (t=="password" || t=="text" || t=="textarea"|| t=="number") && vReadOnly=="readonly")?true:false;
  //当敲Backspace键时，事件源类型非密码或单行、多行文本的，则退格键失效
   var flag2=(ev.keyCode == 8 && t != "password" && t != "text" && t != "textarea"&& t != "number") ?true:false;
  //判断
  if(flag2){
      return false;
  }
  if(flag1){
      return false;
  }
}
window.onload=function(){
  //禁止后退键 作用于Firefox、Opera
  document.onkeypress=banBackSpace;
  //禁止后退键  作用于IE、Chrome
  document.onkeydown=banBackSpace;
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
}

.el-main {
  overflow: auto;background: #dfe2ef;
}

.el-container {
  overflow: auto;
}
.el-header,.el-footer{
  background: #c0cfde;
}
.el-aside{
  background: #8f9eb9;
}
</style>
  


// WEBPACK FOOTER //
// src/App.vue